import { BaseModel } from './BaseModel';
import Credential from './Credential';
import Learner from './Learner';
import LearningUnit from './LearningUnit';
import SectionRepeat from './SectionRepeat';
import UserEnrollment from './UserEnrollment';
import Meeting from './Meeting';
import PostSchedule from './PostSchedule';
export class Section extends BaseModel {
  static get entity() {
    return 'sections';
  }

  static get fk() {
    return 'section_id';
  }

  static fields() {
    return {
      id: this.uid(),
      start_at: this.attr(null),
      end_at: this.attr(false),
      start_enrollment: this.attr(null),
      last_enrollment: this.attr(null),
      max_learners: this.attr(null),
      number_of_learners: this.attr(null),
      is_published: this.boolean(false),
      published_at: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      learning_unit: this.belongsTo(LearningUnit, 'learning_unit_id'),
      learning_unit_id: this.attr(null),
      days_of_week: this.string('[]'),
      online_meeting_start_time: this.string('09:00'),
      [SectionRepeat.fk]: this.attr(null),
      section_repeat: this.belongsTo(SectionRepeat, SectionRepeat.fk),
      user_enrollments_ids: this.attr([]),
      user_enrollments: this.hasManyBy(UserEnrollment, 'user_enrollments_ids', 'section_id'),
      meeting_ids: this.attr([]),
      meetings: this.hasManyBy(Meeting, 'meeting_ids'),
      post_schedules: this.hasMany(PostSchedule, 'post_schedule_id'),
      code: this.attr(null),
      is_default: this.attr(null)
    };
  }

  countEnrolledUser() {
    let count = 0;

    if (this.user_enrollments_ids?.length) {
      count = UserEnrollment.query().whereIdIn(this.user_enrollments_ids).count();
    }

    return count;
  }

  hasEnrollUser(id) {
    const { user_enrollments_ids = [] } = this;

    const user_enrollments = UserEnrollment.findIn(user_enrollments_ids);

    return user_enrollments.some(({ uid } = {}) => uid && uid == id);
  }

  reachStartDate() {
    return new Date() >= new Date(this.start_at);
  }

  static apiConfig = {
    actions: {
      fetch(params = {}) {
        return this.get(`/sections`, {
          params
        });
      },

      fetchById(id) {
        return this.get(`/sections/${id}`);
      },

      createSection(body) {
        return this.post(`/sections`, body);
      },

      updateSection(id, data) {
        return this.put(`/sections/${id}`, data);
      },

      deleteSection(id) {
        return this.delete(`/sections/${id}`, { delete: id });
      },

      fetchLiveSection(uid) {
        return this.get(`/teacher/${uid}/sections/live`);
      },

      async validate(body) {
        const { response } = await this.post(`/sections/validate`, body, { save: false });

        const { data = [] } = response;

        console.log(data);

        return data;
      },

      async fetchGrantCredential(id) {
        const { response } = await this.get(`/sections/${id}/credentials`, {
          save: false
        });

        const { data = [] } = response;

        if (data.length) {
          data.forEach(({ credential, learner } = {}) => {
            if (learner) {
              Learner.insert({
                data: [learner]
              });
            }

            if (credential) {
              Credential.insert({
                data: [credential]
              });
            }
          });
        }

        return data;
      },

      async fetchAllStatusAssessmentCriteriaInSection(id, learningOutcomeId) {
        const { response } = await this.get(
          `/sections/${id}/ultimateLearningOutcomeId/${learningOutcomeId}/criteria-status`,
          {
            save: false
          }
        );
        const { data = [] } = response;
        return data;
      }
    }
  };
}

export default Section;
